document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('.menu-toggle');
  const siteNav = document.querySelector('#SiteNav');
  if (menuToggle && siteNav) {
    const menuLabel = menuToggle.querySelector('.visually-hidden');
    const closeMenu = (restoreFocus = false) => {
      menuToggle.setAttribute('aria-expanded', 'false');
      siteNav.classList.remove('is-open');
      if (menuLabel) menuLabel.textContent = 'Open menu';
      if (restoreFocus) menuToggle.focus();
    };

    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      siteNav.classList.toggle('is-open', !isOpen);
      if (menuLabel) menuLabel.textContent = isOpen ? 'Open menu' : 'Close menu';
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && siteNav.classList.contains('is-open')) closeMenu(true);
    });

    document.addEventListener('click', (event) => {
      if (!siteNav.classList.contains('is-open')) return;
      if (!siteNav.contains(event.target) && !menuToggle.contains(event.target)) closeMenu();
    });
  }

  const activateProductMedia = (gallery, mediaId, focusThumbnail = false) => {
    if (!gallery || !mediaId) return;
    const panels = [...gallery.querySelectorAll('[data-media-panel]')];
    const thumbnails = [...gallery.querySelectorAll('[data-media-thumbnail]')];
    const nextPanel = panels.find((panel) => panel.dataset.mediaPanel === String(mediaId));
    if (!nextPanel) return;

    panels.forEach((panel) => {
      const isActive = panel === nextPanel;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
      if (!isActive) panel.querySelector('video')?.pause();
    });

    thumbnails.forEach((thumbnail) => {
      const isActive = thumbnail.dataset.mediaThumbnail === String(mediaId);
      thumbnail.classList.toggle('is-active', isActive);
      thumbnail.setAttribute('aria-pressed', String(isActive));
      if (isActive && focusThumbnail) thumbnail.focus();
    });
  };

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    gallery.querySelectorAll('[data-media-thumbnail]').forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        activateProductMedia(gallery, thumbnail.dataset.mediaThumbnail);
      });
    });
  });

  const form = document.querySelector('[data-product-form]');

  // Dropdown accessibility
  document.querySelectorAll('.has-dropdown').forEach((dropdown) => {
    const link = dropdown.querySelector('a[aria-haspopup="true"]');
    if (!link) return;
    const mobileQuery = window.matchMedia('(max-width: 900px)');
    const syncDisclosureState = () => {
      if (mobileQuery.matches) link.removeAttribute('aria-expanded');
      else link.setAttribute('aria-expanded', 'false');
    };
    
    const toggleExpanded = (expanded) => {
      if (link.hasAttribute('aria-expanded')) link.setAttribute('aria-expanded', String(expanded));
    };

    syncDisclosureState();
    mobileQuery.addEventListener?.('change', syncDisclosureState);
    dropdown.addEventListener('mouseenter', () => toggleExpanded(true));
    dropdown.addEventListener('mouseleave', () => toggleExpanded(false));
    dropdown.addEventListener('focusin', () => toggleExpanded(true));
    dropdown.addEventListener('focusout', (e) => {
      if (!dropdown.contains(e.relatedTarget)) {
        toggleExpanded(false);
      }
    });
  });

  if (!form) return;

  const select = form.querySelector('[data-variant-select]');
  const price = document.querySelector('[data-product-price]');
  const addLabel = form.querySelector('[data-add-label]');
  const addButton = form.querySelector('.add-button');
  const status = form.querySelector('[data-variant-status]');
  const variantsElement = form.querySelector('[data-product-variants]');
  const optionInputs = [...form.querySelectorAll('.variant-value input')];
  let variants = [];
  try {
    variants = JSON.parse(variantsElement?.textContent || '[]');
  } catch {
    variants = [];
  }

  const syncVariant = () => {
    if (!select) return;
    const selectedOptions = [];
    optionInputs.filter((input) => input.checked).forEach((input) => {
      selectedOptions[Number(input.dataset.optionPosition) - 1] = input.value;
    });
    let matchingVariant = null;
    if (selectedOptions.length && variants.length) {
      matchingVariant = variants.find((variant) =>
        variant.options.length === selectedOptions.length &&
        variant.options.every((value, index) => value === selectedOptions[index])
      );
      if (matchingVariant) {
        select.value = String(matchingVariant.id);
        if (matchingVariant.featured_media?.id) {
          activateProductMedia(document.querySelector('[data-product-gallery]'), matchingVariant.featured_media.id);
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', matchingVariant.id);
        window.history.replaceState({}, '', url);
      } else {
        select.selectedIndex = -1;
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Combination unavailable';
        if (status) status.textContent = 'This option combination is unavailable. Please choose another combination.';
        return;
      }
    }
    const selected = select.options[select.selectedIndex];
    if (!selected) return;
    if (price && selected.dataset.price) price.textContent = selected.dataset.price;
    const available = selected.dataset.available === 'true';
    if (addButton) addButton.disabled = !available;
    if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
    if (status) status.textContent = available ? 'Available' : 'Sold out';
  };

  optionInputs.forEach((input) => input.addEventListener('change', syncVariant));
  select?.addEventListener('change', syncVariant);
  form.addEventListener('submit', (event) => {
    if (!select?.value) {
      event.preventDefault();
      if (status) status.textContent = 'Choose an available option combination before adding this product.';
    }
  });
  syncVariant();
});